import React, { Fragment, useState } from 'react';
import { useInstantSearch } from 'react-instantsearch-hooks-web';
import SearchModal from '../SearchModal';
import SearchFiltersGroupStatusAvail from './SearchFiltersGroupStatusAvail';
import SearchFiltersGroupHomeDetails from './SearchFiltersGroupHomeDetails';
import SearchFiltersGroupPrice from './SearchFiltersGroupPrice';
import SearchFiltersGroupMore from './SearchFiltersGroupMore';
import IconFilters from '../../ui/icons/IconFilters';
import useSearchHasRefinement from '../hooks/useSearchHasRefinement';
import classNames from 'classnames';

const SearchFiltersMobile = ( ) => {
	const api = useInstantSearch();
	const [ isOpen, setIsOpen ] = useState( false );
	const headerText = api.results.index.includes( 'homes' ) ? 'Home & Floorplan Filters' : 'Neighborhood Filters';
	const { hasRefinement } = useSearchHasRefinement();

	const handleClose = () => {
		setIsOpen( false );
	};

	const buttonClasses = classNames( {
		'btn-tiny--platinum': ! hasRefinement,
		'btn-tiny--aloe': hasRefinement,
	} );

	return (
		<>
			<button
				type="button"
				aria-label="Open filters"
				disabled={api.results.hits.length === 0}
				className={`btn-tiny ${ buttonClasses }`}
				onClick={() => {
					setIsOpen( true );
				}}
			>
				<IconFilters />
				<span>
					Filter
				</span>
			</button>
			<SearchModal isShown={isOpen} onClose={handleClose} headerText={headerText}>
				<div className="tw-px-5 tw-pt-5">
					<SearchFiltersGroupStatusAvail />
					<SearchFiltersGroupHomeDetails />
					<SearchFiltersGroupPrice />
					<div className="tw-mt-6">
						<SearchFiltersGroupMore />
					</div>
				</div>
				<div className='tw-sticky tw-bottom-0 tw-w-full tw-left-0 tw-mt-8 tw-z-10'>
					<button
						aria-label="Apply filters and close modal"
						type="button"
						className="btn-full btn-outline btn-outline--apple tw-bg-white" onClick={handleClose}>
					Apply Filters
					</button>
				</div>
			</SearchModal>
		</>
	);
};

export default SearchFiltersMobile;
